import '@/styles/main.scss'
import '@pebble/core'
import '@pebble/tables/dist/pebble-tables.css'
import { createApp } from 'vue'
import App from './App.vue'
import { clickOutside } from '@/directives/click-outside'
import { createPinia } from 'pinia'
import { router } from '@/router'
import { pebbleToastsPlugin } from '@/plugins/pebble-toasts-plugin'
import { i18n } from '@/utils/i18n'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import FloatingVue from 'floating-vue'
import { sdk } from '@/authentication/coodeSdkConfig'
import { initializeTheme } from '@/composables/useTheme'
import { registerEchartsThemes } from '@/utils/echarts-theme'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})

const app = createApp(App)

app.use(FloatingVue)
app.use(VueQueryPlugin, { queryClient })
app.use(i18n)
app.use(createPinia())
app.use(router)
app.use(pebbleToastsPlugin, {
    position: 'bottom-right',
    duration: 2000,
})

app.directive('click-outside', clickOutside)

initializeTheme()
registerEchartsThemes()

sdk?.auth?.init().then(() => app.mount('#app'))
